import { render, staticRenderFns } from "./statement-komisi.vue?vue&type=template&id=6ef3a066&"
import script from "./statement-komisi.vue?vue&type=script&lang=js&"
export * from "./statement-komisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports